import { gql } from '@apollo/client';
import { HealthQuestionnaireOnOfferFragmentDoc } from '../fragments/healthQuestionnaireOnOffer.fragment';

export const getOffersAdditional = gql`
  ${HealthQuestionnaireOnOfferFragmentDoc}
  query GetOffersBySoId($id: String!) {
  getOffersBySoId(id: $id) {
    _id
    status
    productTypeSpecific {
      shoppingCartId
      ...HealthQuestionnaireOnOffer
      additional {
        code
        coverages { code label description }
        priceChangeModifier { amount type description }
        voucherPriceModifier { amount }
        voucherPriceChangeModifier { amount type description code }
        gratis { additionalSecondOpinion }
      }
      calculatedPrices {
        additional { baseProductPrice total { generalTransfer creditCard } }
        total { generalTransfer generalTransferWithInstallments creditCard creditCardWithInstallments }
      }
      insuredPerson {
        firstName
        lastName
        birthDate
        partnerContactEmail
        importantNote
        gender
      }
    }
    product {
      name
      code
      premiumEligibleAgeMin
      premiumEligibleAgeMax
      brand { code name logoUrl}
      annotations
      fixedCoverages { code label description }
    }
  }
}
`
